// A human coach viewing a v2 athlete (the cutover's precondition 5). The
// coach's app reads GET /v2/me/viewing?athlete_id= for the athlete's mode;
// a v2 athlete is then shown through the same v2 client, with every read
// carrying `athlete_id` (the backend's get_viewable_user_id) and nothing
// written: no commands, no composer.

/** The read-only refusal the client and the screens show. */
export const READ_ONLY_REASON = "You're viewing this athlete's plan: it's read-only.";

/**
 * `api` (v2API) with every read bound to `athleteId`, and `command` refusing
 * locally (403) so nothing a screen sends while viewing reaches the backend.
 */
export function viewerAPI(api, athleteId) {
  const as = { athleteId };
  return {
    ...api,
    calendar: (from, to) => api.calendar(from, to, as),
    sync: (afterSeq) => api.sync(afterSeq, as),
    thread: (before = null, filter = null) => api.thread(before, filter, as),
    session: (id) => api.session(id, as),
    strategy: () => api.strategy(as),
    injuries: () => api.injuries(as),
    recovery: (days) => api.recovery(days, as),
    openStream: (afterSeq, signal) => api.openStream(afterSeq, signal, as),
    command: async () => ({ status: 403, data: { detail: READ_ONLY_REASON } }),
    athleteId,
  };
}

/**
 * Which v2 state the app shows, from what it read: `self` (/v2/me, the
 * signed-in athlete) or `viewing` (/v2/me/viewing, the athlete a coach is
 * viewing; null when it answered 403 or failed). Every athlete is v2, so v2
 * is on whenever that read answered (whatever its coach_mode); it is
 * read-only while viewing.
 */
export function v2Mode({ isViewingAthlete, me = null, viewing = null }) {
  if (isViewingAthlete) {
    const on = Boolean(viewing?.user_id);
    return { enabled: on, readOnly: true, me: on ? viewing : null, userId: on ? viewing.user_id : null, athleteId: on ? viewing.user_id : null };
  }
  const on = Boolean(me?.user_id);
  return { enabled: on, readOnly: false, me, userId: on ? me.user_id : null, athleteId: null };
}
